import { PromotionRouteEnum, RoutesEnum } from '~/enums/'
import { IFrameGameURLEnum } from '#lib/enums'

export const META_CONTENTS = (brandName: string) => {
  return [
    {
      category: 'Homepage',
      page: 'Trang chủ',
      seo_url: RoutesEnum.Home,
      meta_title: `${brandName} - Nhà cái uy tín đến từ Châu Âu - Phát lộc mỗi ngày`,
      meta_description: `Trải nghiệm tại ${brandName}- Nhà cái châu Âu uy tín, được cấp phép bởi Curacao Gaming License. Trải nghiệm cá cược đỉnh cao, thưởng lớn phát lộc mỗi ngày!`,
      meta_keywords: `${brandName}, nhà cái ${brandName}, nha cai ${brandName}`,
      heading_1: `${brandName} - Nhà cái uy tín đến từ Châu Âu - Phát lộc mỗi ngày`,
    },
    {
      category: 'Thể thao',
      page: 'Thể thao',
      seo_url: RoutesEnum.Sports,
      meta_title: `Thể thao ${brandName} - Sảnh cược thể thao hấp dẫn với đa dạng kèo cược`,
      meta_description: `Tham gia cá cược thể thao đỉnh cao tại ${brandName} - Tỷ lệ kèo hấp dẫn, cập nhật nhanh, đa dạng môn thi đấu và sảnh cược hàng đầu châu Âu.`,
      meta_keywords: `Thể thao ${brandName}, kèo nhà cái ${brandName}, tỷ lệ kèo ${brandName}, kèo bóng ${brandName}`,
      heading_1: `Thể thao ${brandName} - Sảnh cược thể thao hấp dẫn với đa dạng kèo cược`,
    },
    {
      category: '',
      page: 'K Sports',
      seo_url: IFrameGameURLEnum.K_SPORTS,
      meta_title: `K Sports - Khám phá sảnh thể thao hot nhất tại ${brandName}`,
      meta_description: `K Sports ${brandName} - Sảnh cược thể thao chuẩn châu Âu, giao diện mượt mà, tỷ lệ cạnh tranh, đặt cược siêu tốc mỗi ngày.`,
      meta_keywords: `KSport, KSport ${brandName}, Sảnh cược thể thao K-Sport`,
      heading_1: `K Sports - Khám phá sảnh thể thao hot nhất tại ${brandName}`,
    },
    {
      category: '',
      page: 'A Sports',
      seo_url: IFrameGameURLEnum.I_SPORTS,
      meta_title: `Trải nghiệm cá cược A Sports tại ${brandName} - dễ chơi, dễ trúng`,
      meta_description: `Sảnh cược thể thao A-Sport - Cập nhật kèo liên tục, cược trực tiếp ổn định, tỷ lệ cao, dễ chơi, dễ thắng.`,
      meta_keywords: `ASport, ASport ${brandName}, Sảnh cược thể thao A-Sport`,
      heading_1: `Trải nghiệm cá cược A Sports tại ${brandName} - dễ chơi, dễ trúng`,
    },
    {
      category: '',
      page: 'P Sports',
      seo_url: IFrameGameURLEnum.C_SPORTS,
      meta_title: `P Sports - Cược thể thao không giới hạn, đặt cược ngay!`,
      meta_description: `Khám phá ngay sảnh cược P Sports đa kèo, cược nhanh chỉ có tại nhà cái ${brandName} với giao diện thân thiện, thưởng liền tay`,
      meta_keywords: `PSport, PSport ${brandName}, Sảnh cược thể thao P-Sport`,
      heading_1: `P Sports - Cược thể thao không giới hạn, đặt cược ngay!`,
    },
    {
      category: '',
      page: 'I Sports',
      seo_url: IFrameGameURLEnum.M_SPORTS,
      meta_title: `I Sports - Đặt cược nhanh, thưởng liền tay & siêu hấp dẫn`,
      meta_description: `Tham gia ngay I Sports ${brandName} – Sảnh cá cược thể thao quốc tế với tỷ lệ chuẩn châu Âu, kết quả minh bạch, cược linh hoạt.`,
      meta_keywords: `ISport, ISport ${brandName}, Sảnh cược thể thao I-Sport`,
      heading_1: `I Sports - Đặt cược nhanh, thưởng liền tay & siêu hấp dẫn`,
    },
    {
      category: '',
      page: 'M Sports',
      seo_url: IFrameGameURLEnum.P_SPORTS,
      meta_title: `M-Sports | Kèo cược bóng đá uy tín tại ${brandName}`,
      meta_description: `M-Sports - Sảnh cược cập nhật bảng tỷ lệ kèo nhà cái ${brandName} mới nhất với tỷ lệ hoàn trả số 1 Châu Âu.`,
      meta_keywords: `MSport, MSport ${brandName}, Sảnh cược thể thao M-Sport`,
      heading_1: `M-Sports ${brandName} - Sảnh kèo bóng đá số một Châu Âu`,
    },
    // {
    //   category: '',
    //   page: 'T Sports',
    //   seo_url: IFrameGameURLEnum.T_SPORTS,
    //   meta_title: `Đặt cược thể thao T Sports cực đã & thưởng liền tay tại ${brandName}`,
    //   meta_description: `T Sports ${brandName} - Sảnh cược thể thao uy tín, tốc độ xử lý nhanh, đa dạng kèo, đặt đâu ăn đó.`,
    //   meta_keywords: `TSport, TSport ${brandName}, Sảnh cược thể thao T-Sport`,
    //   heading_1: `Đặt cược thể thao T Sports cực đã & thưởng liền tay tại ${brandName}`,
    // },
    {
      category: '',
      page: 'Thể thao ảo',
      seo_url: IFrameGameURLEnum.VIRTUAL_SPORTS,
      meta_title: `Thể thao ảo ${brandName} - Giải trí không giới hạn, cược là dính - Chơi là mê`,
      meta_description: `Thể thao ảo ${brandName} - Nơi các cược thủ thỏa mãn niềm đam mê cá cược, kết quả siêu tốc, tỷ lệ kèo được cập nhật rõ ràng, minh bạch.`,
      meta_keywords: `Thể thao ảo ${brandName}, cá cược thể thao ảo, kèo thể thao ảo ${brandName}`,
      heading_1: `Thể thao ảo ${brandName} - Giải trí không giới hạn, cược là dính - Chơi là mê`,
    },
    {
      category: '',
      page: 'Thể thao điện tử',
      seo_url: IFrameGameURLEnum.ESPORTS,
      meta_title: `Cược thể thao điện tử ${brandName} - Tỷ lệ cao, cược cực đã, không giới hạn!`,
      meta_description: `Khám phá ngay sảnh thể thao điện tử tại ${brandName} - Tỷ lệ kèo cực tốt, cược live mượt mà, thưởng lớn mỗi ngày!`,
      meta_keywords: `ESport ${brandName}, cược thể thao điện tử ${brandName}, e-sport ${brandName}`,
      heading_1: `Cược thể thao điện tử ${brandName} - Tỷ lệ cao, cược cực đã, không giới hạn!`,
    },
    {
      category: 'live-casino',
      page: 'Tài Xỉu',
      seo_url: '/tai-xiu',
      meta_title: `Tài xỉu online ${brandName} - Lắc là dính, thắng là mê`,
      meta_description: `Game tài xỉu đổi thưởng hấp dẫn tại ${brandName} - tỷ lệ ăn cao, luật chơi đơn giản, cực kỳ dễ trúng.`,
      meta_keywords: `tài xỉu online, tài xỉu ${brandName}, game tài xỉu, game bài đổi tiền thật`,
      heading_1: `Tài xỉu online ${brandName} - Lắc là dính, thắng là mê`,
    },
    {
      category: 'live-casino',
      page: 'Xóc Đĩa',
      seo_url: '/xoc-dia',
      meta_title: `Thử vận may cùng xóc đĩa trực tuyến ${brandName} siêu cuốn`,
      meta_description: `Xóc đĩa trực tuyến ${brandName} - vào là chơi, lắc là trúng, nhận thưởng nóng mỗi ngày!`,
      meta_keywords: `xóc đĩa, xóc đĩa trực tuyến, xóc đĩa ${brandName}, xóc đĩa online`,
      heading_1: `Thử vận may cùng xóc đĩa trực tuyến ${brandName} siêu cuốn`,
    },
    {
      category: 'live-casino',
      page: 'Bầu Cua',
      seo_url: '/bau-cua',
      meta_title: `Bầu cua ${brandName} - Chơi là mê, rinh quà lớn`,
      meta_description: `Bầu cua trực tuyến - chơi cực dễ, đặt cược nhanh, quà tặng siêu khủng tại ${brandName}.`,
      meta_keywords: `bầu cua, bầu cua ${brandName}, bầu cua online, bầu cua trực tuyến`,
      heading_1: `Bầu cua ${brandName} - Chơi là mê, rinh quà lớn`,
    },
    {
      category: 'live-casino',
      page: 'Baccarat',
      seo_url: '/baccarat',
      meta_title: `Baccarat online ${brandName} - Đẳng cấp sòng bài châu Âu`,
      meta_description: `Baccarat online tại ${brandName} - cược cực chuẩn, chia bài siêu nhanh, thưởng lớn mỗi ngày.`,
      meta_keywords: `baccarat, baccarat trực tuyến, baccarat online, baccarat ${brandName}`,
      heading_1: `Baccarat online ${brandName} - Đẳng cấp sòng bài châu Âu`,
    },
    {
      category: 'live-casino',
      page: 'Blackjack',
      seo_url: '/blackjack',
      meta_title: `Game blackjack online ${brandName} - Đủ thách thức cho dân chơi pro`,
      meta_description: `Blackjack online tại nhà cái ${brandName}, anh em chơi cực đã, thắng cực nhanh, rút tiền về ví chỉ vài phút.`,
      meta_keywords: `blackjack, blackjack online, blackjack ${brandName}`,
      heading_1: `Game blackjack online ${brandName} - Đủ thách thức cho dân chơi pro`,
    },
    {
      category: 'live-casino',
      page: 'Roulette',
      seo_url: '/roulette',
      meta_title: `Trải nghiệm Roulette trực tuyến đẳng cấp châu Âu tại ${brandName}`,
      meta_description: `Roulette online ${brandName} - vòng quay đổi đời, đặt cực đơn giản, ăn tiền dễ dàng.`,
      meta_keywords: `roulette, roulette online, roulette ${brandName}`,
      heading_1: `Trải nghiệm Roulette trực tuyến đẳng cấp châu Âu tại ${brandName}`,
    },
    {
      category: 'live-casino',
      page: 'Poker',
      seo_url: '/poker',
      meta_title: `Poker online ${brandName} - So tài đỉnh cao, đặt cược cực lớn`,
      meta_description: `Poker online tại ${brandName} - đấu trí đỉnh cao, rinh tiền khủng mỗi ngày cho người chơi bản lĩnh.`,
      meta_keywords: `poker, poker online, poker ${brandName}`,
      heading_1: `Poker online ${brandName} - So tài đỉnh cao, đặt cược cực lớn`,
    },
    {
      category: 'live-casino',
      page: 'Sicbo',
      seo_url: '/sicbo',
      meta_title: `Sicbo ${brandName} - Cược cực đã, thắng lớn chỉ với một lần lắc`,
      meta_description: `Sicbo trực tuyến ${brandName} - giao diện chân thực, đặt cược dễ dàng, rút thưởng siêu tốc.`,
      meta_keywords: `sicbo, sicbo ${brandName}`,
      heading_1: `Sicbo ${brandName} - Cược cực đã, thắng lớn chỉ với một lần lắc`,
    },
    {
      category: 'live-casino',
      page: 'Casino',
      seo_url: RoutesEnum.LiveCasino,
      meta_title: `Casino ${brandName} - Trải nghiệm thế giới giải trí đỉnh cao, chơi là thắng`,
      meta_description: `Casino online uy tín ${brandName} - đẳng cấp châu Âu, chơi thả ga, đổi thưởng cực nhanh, bảo mật tuyệt đối.`,
      meta_keywords: `casino trực tuyến, casino online, casino trực tuyến uy tín, casino online uy tín, casino ${brandName}, `,
      heading_1: `Casino ${brandName} - Trải nghiệm thế giới giải trí đỉnh cao, chơi là thắng`,
    },
    {
      category: 'tro-choi',
      page: 'Game Bài',
      seo_url: RoutesEnum.GameBai,
      meta_title: `Thử vận may cùng game bài ${brandName} - Chơi dễ, thắng lớn, rút nhanh.`,
      meta_description: `Chơi game bài tại ${brandName}, đổi thưởng cực nhanh, tỷ lệ thắng cao. Cược game bài online ngay và nhận thưởng hấp dẫn!`,
      meta_keywords: `game bài, game bài ${brandName}, game bài đổi thưởng, game đánh bài, đánh bài online`,
      heading_1: `Thử vận may cùng game bài ${brandName} - Chơi dễ, thắng lớn, rút nhanh.`,
    },
    {
      category: 'tro-choi',
      page: 'Slots',
      seo_url: RoutesEnum.Slots,
      meta_title: `Cược slots tại ${brandName} - Nhận thưởng lớn sau mỗi vòng quay đầy may mắn!`,
      meta_description: `Quay slots tại ${brandName} và rinh ngay những phần thưởng hấp dẫn. Trải nghiệm slot game đổi thưởng một cách dễ dàng.`,
      meta_keywords: `game đổi thưởng, game ${brandName}, game tiền thật ${brandName}`,
      heading_1: `Cược slots tại ${brandName} - Nhận thưởng lớn sau mỗi vòng quay đầy may mắn!`,
    },
    {
      category: 'tro-choi',
      page: 'Lô Đề',
      seo_url: RoutesEnum.Lode,
      meta_title: `Lô đề trực tuyến tại ${brandName} – Đặt cược dễ dàng, rút thưởng tức thì`,
      meta_description: `Lô đề online tại ${brandName} - Cược xổ số truyền thống, dễ chơi và nhận thưởng ngay lập tức. Thử vận may ngay!`,
      meta_keywords: `lô đề online, lô đề ${brandName}, xổ số truyền thống, đánh lô đề online`,
      heading_1: `Lô đề trực tuyến tại ${brandName} – Đặt cược dễ dàng, rút thưởng tức thì`,
    },
    {
      category: 'tro-choi',
      page: 'Bắn Cá',
      seo_url: RoutesEnum.Fishing,
      meta_title: `Trải nghiệm bắn cá ${brandName} - Thắng cực dễ, đổi tiền thật liền tay`,
      meta_description: `Trải nghiệm chơi bắn cá tại ${brandName} - Thử vận may, đổi thưởng nhanh, rút tiền siêu tốc chỉ với vài cú click`,
      meta_keywords: `bắn cá ${brandName}, bắn cá online, bắn cá đổi thưởng, bắn cá đổi tiền thật, bắn cá trực tuyến, bắn cá rút tiền thật`,
      heading_1: `Trải nghiệm bắn cá ${brandName} - Thắng cực dễ, đổi tiền thật liền tay`,
    },
    {
      category: 'tro-choi',
      page: 'Quick Game',
      seo_url: RoutesEnum.InstantGames,
      meta_title: `Quick Game tại ${brandName} - Đổi thưởng tức thì, không cần chờ đợi!`,
      meta_description: `Quick game ${brandName} - Chơi cực nhanh, đổi thưởng ngay lập tức. Anh em đừng bỏ lỡ cơ hội thắng lớn!`,
      meta_keywords: `game nhanh, chơi game nhanh, game trả thưởng nhanh, game nhanh ${brandName}`,
      heading_1: `Quick Game tại ${brandName} - Đổi thưởng tức thì, không cần chờ đợi!`,
    },
    {
      category: 'tro-choi',
      page: 'Quay số',
      seo_url: RoutesEnum.NumberGames,
      meta_title: `Quay số ${brandName} - Quay là thắng, thử vận may ngay!`,
      meta_description: `Quay số ${brandName} - Thử vận may với Keno, đổi thưởng nhanh chóng. Thử ngay để nhận thưởng cực lớn!`,
      meta_keywords: `quay số đổi thưởng, trò chơi quay số, ghi số keno, keno, quay số ${brandName}`,
      heading_1: `Quay số ${brandName} - Quay là thắng, thử vận may ngay!`,
    },
    {
      category: 'tro-choi',
      page: 'Game khác',
      seo_url: RoutesEnum.OtherGames,
      meta_title: `Game khác tại ${brandName} - Hàng nghìn game hấp dẫn, đổi thưởng nhanh chóng! `,
      meta_description: `Khám phá game khác tại ${brandName} - Đổi thưởng nhanh chóng, chơi cực vui và dễ thắng. Thử ngay!`,
      meta_keywords: `game đổi thưởng, game ${brandName}, game tiền thật ${brandName}`,
      heading_1: `Game khác tại ${brandName} - Hàng nghìn game hấp dẫn, đổi thưởng nhanh chóng! `,
    },
    {
      category: 'tro-choi',
      page: 'Games',
      seo_url: RoutesEnum.LobbyGame,
      meta_title: `Games ${brandName} - Đổi thưởng thanh chóng, cược lớn, thưởng cao`,
      meta_description: `Game ${brandName} - Trải nghiệm game ăn tiền thật với tỷ lệ thắng cao, đổi thưởng cực nhanh và cực kỳ thú vị.`,
      meta_keywords: `game đổi thưởng, game ${brandName}, game tiền thật ${brandName}`,
      heading_1: `Games ${brandName} - Đổi thưởng thanh chóng, cược lớn, thưởng cao`,
    },
    {
      category: 'tro-choi',
      page: 'Games',
      seo_url: RoutesEnum.LobbyGameAll,
      meta_title: `Games ${brandName} - Đổi thưởng thanh chóng, cược lớn, thưởng cao`,
      meta_description: `Game ${brandName} - Trải nghiệm game ăn tiền thật với tỷ lệ thắng cao, đổi thưởng cực nhanh và cực kỳ thú vị.`,
      meta_keywords: `game đổi thưởng, game ${brandName}, game tiền thật ${brandName}`,
      heading_1: `Games ${brandName} - Đổi thưởng thanh chóng, cược lớn, thưởng cao`,
    },
    {
      category: '',
      page: 'Về Chúng Tôi',
      seo_url: RoutesEnum.About,
      meta_title: `Về chúng tôi - Khám phá ${brandName}, nhà cái hàng đầu châu Âu`,
      meta_description: `Về chúng tôi, giới thiệu ${brandName} - nhà cái đến từ châu Âu uy tín. Hãy cùng khám phá hành trình phát triển cũng như lý do bạn nên đồng hành cùng chúng tôi.`,
      meta_keywords: `giới thiệu ${brandName}, thông tin nhà cái ${brandName}`,
      heading_1: `Về chúng tôi - Khám phá ${brandName}, nhà cái hàng đầu châu Âu`,
    },
    {
      category: '',
      page: 'Câu Hỏi Thường Gặp',
      seo_url: '/thac-mac',
      meta_title: `Câu hỏi thường gặp - Gải đáp thắc mắc của newbie về nhà cái ${brandName}`,
      meta_description: `Tổng hợp những câu hỏi thường gặp tại ${brandName} - chúng tôi sẵn sàng giải đáp chi tiết, nhanh chóng giúp quá trình chơi của bạn không bị gián đoạn.`,
      meta_keywords: `câu hỏi thường gặp, câu hỏi thường gặp ${brandName}`,
      heading_1: `Câu hỏi thường gặp - Gải đáp thắc mắc của newbie về nhà cái ${brandName}`,
    },
    {
      category: '',
      page: 'Privacy policy',
      seo_url: RoutesEnum.PrivacyPolicy,
      meta_title: `Tìm hiểu chính sách bảo mật tại ${brandName}`,
      meta_description: `Chính sách bảo mật tại ${brandName} cam kết giữ an toàn thông tin người chơi 100%, được mã hóa hiện đại, bảo vệ giao dịch 24/7 khi tham gia chơi tại ${brandName}. `,
      meta_keywords: `chính sách bảo mật ${brandName}`,
      heading_1: `Tìm hiểu chính sách bảo mật tại ${brandName}`,
    },
    {
      category: '',
      page: 'Thưởng 150% lần nạp đầu tiên',
      seo_url: PromotionRouteEnum.FirstDepositPromotion,
      meta_title: `Khuyến mãi 150% - ${brandName} | Thưởng Khủng Nhận Ngay Hôm Nay`,
      meta_description: `Nhận ngay 150% khi nạp tiền lần đầu tại ${brandName}. Cùng gấp đôi cơ hội chiến thắng.`,
      meta_keywords: `thưởng 150%, bonus 150%, khuyến mãi ${brandName}, tiền thưởng, thưởng khủng, nạp lần đầu`,
      heading_1: `Nhận Thưởng 150% Tại ${brandName} – Tăng Cơ Hội Chiến Thắng Ngay Hôm Nay!`,
    },
    {
      category: '',
      page: 'Thưởng 70% nạp lần 2',
      seo_url: PromotionRouteEnum.SecondDepositPromotion,
      meta_title: `Khuyến mãi 70% - ${brandName} | Cược Nhiều, Thưởng Khủng`,
      meta_description: `Tận dụng ưu đãi thưởng 70% tại ${brandName} và tối đa vị thế cá cược.`,
      meta_keywords: `thưởng 70%, bonus 70%, khuyến mãi ${brandName}, nạp lần 2`,
      heading_1: `Nhận Thưởng 70% Tại ${brandName} – Tăng Cường Cơ Hội Cược`,
    },
    {
      category: '',
      page: 'Hoàn trả 1.2%',
      seo_url: PromotionRouteEnum.UnlimitedDepositPromotion,
      meta_title: `Hoàn Trả 1.2% - ${brandName} | Quá Đã, Cược Ngay`,
      meta_description: `Tận hưởng chương trình hoàn trả 1.2% cho mỗi lần nạp tại ${brandName} và tham gia cược ngay.`,
      meta_keywords: `hoàn trả 1.2%, cashback ${brandName}, tiền hoàn trả, cược hoàn trả`,
      heading_1: `Nhận Hoàn Trả 1.2% Tại ${brandName} - Tiền Đẻ Ra Tiền`,
    },
    {
      category: '',
      page: 'Khuyến Mãi',
      seo_url: PromotionRouteEnum.Promotion,
      meta_title: `Cập nhật chương trình khuyến mãi hấp dẫn tại nhà cái ${brandName}`,
      meta_description: `Cập nhật khuyến mãi ${brandName} mỗi ngày để nhận ưu đãi khủng cũng như quà tặng hấp dẫn, giftcode giới hạn.`,
      meta_keywords: `khuyến mãi, ưu đãi, khuyến mãi ${brandName}, quà tặng ${brandName}, giftcode ${brandName}`,
      heading_1: `Cập nhật chương trình khuyến mãi hấp dẫn tại nhà cái ${brandName}`,
    },
    {
      category: '',
      page: 'Hướng Dẫn Đăng Ký',
      seo_url: RoutesEnum.InstructRegister,
      meta_title: `Hướng dẫn đăng ký ${brandName} - Cược ngay chỉ trong 5 phút`,
      meta_description: `Hướng dẫn đăng ký tài khoản ${brandName} nhanh chóng, đơn giản, bảo mật chỉ với vài phút để bắt đầu hành trình giải trí đỉnh cao.`,
      meta_keywords: `đăng ký ${brandName}, đăng ký tài khoản ${brandName}`,
      heading_1: `Hướng dẫn đăng ký ${brandName} - Cược ngay chỉ trong 5 phút`,
    },
    {
      category: '',
      page: 'Hướng Dẫn Nạp Tiền',
      seo_url: '/huong-dan/nap-tien',
      meta_title: `Hướng dẫn đăng nhập ${brandName} nhanh chóng, an toàn, dễ hiểu`,
      meta_description: `Hướng dẫn nạp tiền vào tài khoản ${brandName} chi tiết, minh bạch, xử lý siêu tốc cùng độ bảo mật tuyệt đối 100%.`,
      meta_keywords: `nạp tiền ${brandName}, nạp tiền tài khoản ${brandName}`,
      heading_1: `Hướng dẫn đăng nhập ${brandName} nhanh chóng, an toàn, dễ hiểu`,
    },
    {
      category: '',
      page: 'Hướng Dẫn Rút',
      seo_url: '/huong-dan/rut-tien',
      meta_title: `Hướng dẫn rút tiền ${brandName} cực dễ chỉ với vài thao tác`,
      meta_description: `Hướng dẫn rút tiền tại nhà cái ${brandName} cực dễ, thủ tục nhanh gọn, hướng dẫn chi tiết từ A-Z cực mượt mọi lúc mọi nơi.`,
      meta_keywords: `rút tiền ${brandName}, hướng dẫn rút tiền ${brandName}`,
      heading_1: `Hướng dẫn rút tiền ${brandName} cực dễ chỉ với vài thao tác`,
    },
    {
      category: '',
      page: 'Hướng Dẫn Nạp Qua Ngân Hàng',
      seo_url: '/huong-dan/nap-ngan-hang',
      meta_title: `Hướng dẫn nạp qua ngân hàng - tiện lợi, nhanh chóng 100% từ ${brandName}`,
      meta_description: `Hướng dẫn nạp tiền qua ngân hàng tại ${brandName} siêu tốc, kết nối an toàn, hỗ trợ mọi ngân hàng nội địa nhanh chóng.`,
      meta_keywords: `nạp tiền ${brandName}, hướng  dẫn nạp tiền qua ngân hàng ${brandName}`,
      heading_1: `Hướng dẫn nạp qua ngân hàng - tiện lợi, nhanh chóng 100% từ ${brandName}`,
    },
    {
      category: '',
      page: 'Hướng Dẫn Nạp Qua Tiền Ảo',
      seo_url: '/huong-dan/nap-tien-ao',
      meta_title: `Hướng dẫn nạp qua tiền ảo ${brandName} - Nhanh chóng, cực tiện lợi`,
      meta_description: `Hướng dẫn nạp qua tiền ảo - ${brandName} hỗ trợ người chơi nạp USDT & các loại crypto cực nhanh. Hướng dẫn chi tiết cho người mới.`,
      meta_keywords: `nạp tiền ${brandName}, hướng dẫn nạp tiền ảo ${brandName}`,
      heading_1: `Hướng dẫn nạp qua tiền ảo ${brandName} - Nhanh chóng, cực tiện lợi`,
    },
    {
      category: '',
      page: 'Hướng Dẫn Nạp Qua Ví Điện Tử',
      seo_url: '/huong-dan/nap-vi-dien-tu',
      meta_title: `Hướng dẫn nạp qua ví điện tử ${brandName} - Kết nối nhanh, an toàn`,
      meta_description: `Hướng dẫn nạp qua ví điện tử như Momo, Zalopay, Viettel Money,... ${brandName} giúp bạn thực hiện nhanh chóng, dễ dàng.`,
      meta_keywords: `nạp tiền ${brandName}, hướng dẫn nạp tiền ví điện tử ${brandName}`,
      heading_1: `Hướng dẫn nạp qua ví điện tử ${brandName} - Kết nối nhanh, an toàn`,
    },
    {
      category: '',
      page: 'Hướng Dẫn Nạp Qua Thẻ Cào',
      seo_url: '/huong-dan/nap-the-cao',
      meta_title: `Hướng dẫn nạp qua thẻ cào ${brandName} siêu dễ chỉ với vài thao tác đơn giản`,
      meta_description: `Hướng dẫn nạp tiền bằng thẻ cào tại ${brandName} - thuận tiện, không cần tài khoản ngân hàng, xử lý tự động trong 60 giây.`,
      meta_keywords: `nạp tiền ${brandName}, hướng dẫn nạp tiền qua thẻ cào ${brandName}`,
      heading_1: `Hướng dẫn nạp qua thẻ cào ${brandName} siêu dễ chỉ với vài thao tác đơn giản`,
    },
    {
      category: '',
      page: 'Hướng Dẫn Rút Qua Ngân Hàng',
      seo_url: '/huong-dan/rut-tien-ngan-hang',
      meta_title: `Hướng dẫn rút qua ngân hàng ${brandName} an toàn, bảo mật tuyệt đối`,
      meta_description: `Hướng dẫn rút qua ngân hàng ${brandName} chi tiết, minh bạch, bảo mật - xử lý rút tiền siêu tốc mọi thời điểm`,
      meta_keywords: `rút tiền ${brandName}, hướng dẫn rút tiền ${brandName} qua ngân hàng`,
      heading_1: `Hướng dẫn rút qua ngân hàng ${brandName} an toàn, bảo mật tuyệt đối`,
    },
    {
      category: '',
      page: 'Hướng Dẫn Rút Qua Tiền Ảo',
      seo_url: '/huong-dan/rut-tien-ao',
      meta_title: `Hướng dẫn rút qua tiền ảo ${brandName} cực tiện lợi, nhanh chóng`,
      meta_description: `${brandName} hướng dẫn rút qua tiền ảo cực nhanh, theo dõi hết bài vết để rút USDT nhanh chóng chỉ với vài bước cơ bản.`,
      meta_keywords: `rút tiền ${brandName}, hướng dẫn rút tiền ${brandName} qua ví tiền ảo`,
      heading_1: `Hướng dẫn rút qua tiền ảo ${brandName} cực tiện lợi, nhanh chóng`,
    },
    {
      category: '',
      page: 'Hướng Dẫn Rút Qua Thẻ Cào',
      seo_url: '/huong-dan/rut-tien-the-cao',
      meta_title: `Hướng dẫn rút qua thẻ cào ${brandName} đơn giản, nhanh gọn `,
      meta_description: `Hướng dẫn rút qua thẻ cào ${brandName} siêu tiện lợi - nhận mã nhanh chóng, thao tác dễ dàng, hỗ trợ đa nhà mạng.`,
      meta_keywords: `rút tiền ${brandName}, hướng dẫn rút tiền ${brandName} qua thẻ cào`,
      heading_1: `Hướng dẫn rút qua thẻ cào ${brandName} đơn giản, nhanh gọn `,
    },
    {
      category: '',
      page: 'Contact information',
      seo_url: RoutesEnum.ContactUs,
      meta_title: `Liên hệ ${brandName} - Hỗ trợ người chơi 24/7`,
      meta_description: `Hãy liên hệ ngay với bộ phận chăm sóc khách hàng của ${brandName} khi cần được hỗ trợ. Hỗ trợ nhanh, nhiệt tình giúp bạn giải quyết vấn đề nhanh chóng.`,
      meta_keywords: `thông tin liên hệ ${brandName}`,
      heading_1: `Liên hệ ${brandName} - Hỗ trợ người chơi 24/7`,
    },
    {
      category: '',
      page: 'Legal betting',
      seo_url: RoutesEnum.LegalBetting,
      meta_title: `Cược hợp pháp cùng ${brandName} - Giấy phép chuẩn quốc tế`,
      meta_description: `Cược hợp pháp tại ${brandName} được cấp phép bởi Curacao Gaming License, đảm bảo minh bạch, an toàn quốc tế. Tham gia nhà cái uy tín chuẩn châu Âu ngay hôm nay!`,
      meta_keywords: `cược hợp pháp tại ${brandName}`,
      heading_1: `Cược hợp pháp cùng ${brandName} - Giấy phép chuẩn quốc tế`,
    },
    {
      category: '',
      page: 'Term of use',
      seo_url: RoutesEnum.TermsAndConditions,
      meta_title: `Điều khoản điều kiện tại ${brandName} rõ ràng  & minh bạch`,
      meta_description: `Nắm rõ điều khoản điều kiện tại nhà cái ${brandName} khi tham gia chơi sẽ giúp quá trình cược diễn ra một cách thuận lợi, minh bạch.`,
      meta_keywords: `điều khoản điều kiện ${brandName}`,
      heading_1: `Điều khoản điều kiện tại ${brandName} rõ ràng  & minh bạch`,
    },
    {
      category: '',
      page: 'Soi kèo bóng đá',
      seo_url: RoutesEnum.SoiKeo,
      meta_title: `Soi kèo bóng đá ${brandName} - Cập nhật tỷ lệ kèo nhanh, kèo hot, tỷ lệ hấp dẫn`,
      meta_description: `Soi kèo bóng đá tại ${brandName} với tỷ lệ kèo hấp dẫn và cập nhật nhanh nhất. Tham gia ngay để không bỏ lỡ cơ hội thắng lớn từ nhà cái.`,
      meta_keywords: `tin tức ${brandName} , cập nhật mới nhất, khuyến mãi ${brandName} , thông báo ${brandName}`,
      heading_1: `Soi kèo bóng đá ${brandName} - Cập nhật tỷ lệ kèo nhanh, kèo hot, tỷ lệ hấp dẫn`,
    },
    {
      category: '',
      page: 'Soi kèo bóng đá',
      seo_url: RoutesEnum.TinNoiBat,
      meta_title: `Soi kèo bóng đá ${brandName} - Cập nhật tỷ lệ kèo nhanh, kèo hot, tỷ lệ hấp dẫn`,
      meta_description: `Soi kèo bóng đá tại ${brandName} với tỷ lệ kèo hấp dẫn và cập nhật nhanh nhất. Tham gia ngay để không bỏ lỡ cơ hội thắng lớn từ nhà cái.`,
      meta_keywords: `tin tức ${brandName} , cập nhật mới nhất, khuyến mãi ${brandName} , thông báo ${brandName}`,
      heading_1: `Soi kèo bóng đá ${brandName} - Cập nhật tỷ lệ kèo nhanh, kèo hot, tỷ lệ hấp dẫn`,
    },
    {
      category: '',
      page: 'Nhận định bóng đá',
      seo_url: RoutesEnum.FootballNews,
      meta_title: `Nhận định bóng đá hôm nay tại ${brandName} - Soi kèo nhanh, dự đoán chính xác`,
      meta_description: `Nhận định bóng đá hôm nay tại nhà cái ${brandName} - Soi kèo chính xác, tỷ lệ cao. Cược thông minh, chiến thắng lớn! Tham gia ngay để nhận thưởng hấp dẫn nào.`,
      meta_keywords: `tin tức ${brandName} , cập nhật mới nhất, khuyến mãi ${brandName} , thông báo ${brandName} `,
      heading_1: `Nhận định bóng đá hôm nay tại ${brandName} - Soi kèo nhanh, dự đoán chính xác`,
    },
    {
      category: '',
      page: 'Tip bóng đá',
      seo_url: RoutesEnum.TipFootball,
      meta_title: `Tip bóng đá ${brandName} - Cập nhật mẹo cược chính xác từ chuyên gia`,
      meta_description: `Nhận tip bóng đá đỉnh cao từ chuyên gia tại ${brandName} - Soi kèo chuẩn xác, tỷ lệ thắng cao. Đặt cược ngay để bứt phá, chiến thắng cực đã!`,
      meta_keywords: `tin tức ${brandName} , cập nhật mới nhất, khuyến mãi ${brandName} , thông báo ${brandName}`,
      heading_1: `Tip bóng đá ${brandName} - Cập nhật mẹo cược chính xác từ chuyên gia`,
    },
    {
      category: '',
      page: 'Lô đề Online',
      seo_url: RoutesEnum.LodeOnline,
      meta_title: `Lô đề Online ${brandName} - Cược nhanh, nhận thưởng liền tay, minh bạch`,
      meta_description: `Cược lô đề Online tại ${brandName} - Tỷ lệ cao, minh bạch, kết quả nhanh chóng. Tham gia ngay để thử vận may ngay thôi nào!`,
      meta_keywords: `tin tức ${brandName} , cập nhật mới nhất, khuyến mãi ${brandName} , thông báo ${brandName}`,
      heading_1: `Lô đề Online ${brandName} - Cược nhanh, nhận thưởng liền tay, minh bạch`,
    },
    {
      category: '',
      page: 'Tin Tức',
      seo_url: RoutesEnum.News,
      meta_title: `Tin tức ${brandName} - Cập nhật thông tin khuyến mãi, cá cược chuẩn xác`,
      meta_description: `Cập nhật tin tức ${brandName} mới nhất, khuyến mãi hấp dẫn và thông báo từ nhà cái. Đừng bỏ lỡ cơ hội cược thắng lớn mỗi ngày -Tham gia ngay!`,
      meta_keywords: `tin tức ${brandName} , cập nhật mới nhất, khuyến mãi ${brandName} , thông báo ${brandName}`,
      heading_1: `Tin tức ${brandName} - Cập nhật thông tin khuyến mãi, cá cược chuẩn xác`,
    },
  ]
}
